import React from 'react';
import './css/GospelMessage.css';

const GospelMessage = () => {
  return (
    <div className="gospel-banner">
      <div className="gospel-banner-inner">
        <div className="gospel-icon">✝</div>

        <h2 className="gospel-title">Good News of the Lord Jesus Christ</h2>

        <a
          className="gospel-video-link"
          href="https://youtu.be/t1BWSOVNm4A"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="gospel-play-icon">▶</span> Watch the message
        </a>

        <h3 className="gospel-subtitle">The Gospel Message</h3>

        <p className="gospel-paragraph">
          We have all sinned and fallen short of the glory of God (Romans 3:23). Not only did we sin in our
          deeds, but we also sinned in our thoughts. God judges even our thoughts and
          intentions. It is written: <em>&ldquo;&hellip;everyone who looks at a woman with
          lustful intent has already committed adultery with her in his heart&rdquo;</em>
          (Matthew 5:28). And also: <em>&ldquo;Everyone who hates his brother is a
          murderer&hellip;&rdquo;</em> (1 John 3:15). The Bible likens idolatry to the sins of
          sexual immorality and prostitution: <em>&ldquo;For they have committed adultery, and
          blood is on their hands. They committed adultery with their idols; they even sacrificed
          their children&mdash;whom they bore to Me&mdash;to the idols as food&rdquo;</em>
          (Ezekiel 23:37). <em>&ldquo;They defiled themselves by their deeds and prostituted
          themselves by their actions&rdquo;</em> (Psalm 105:39). Therefore, those who worship
          idols can be compared to those who commit adultery and prostitution, for they do not
          worship the true Triune God, to whom we owe worship and faithfulness under the covenant
          made with Adam: <em>&ldquo;Like Adam, you have broken the covenant; there you were
          unfaithful to Me&rdquo;</em> (Hosea 6:7). Abortion is a sin because it is a murder of a
          human being because the Bible says that human life starts at conception:
          <em>&ldquo;For you formed my inward parts; you knitted me together in my
          mother&rsquo;s womb.&rdquo;</em> (Psalm 139:13). Homosexuality is a sin and a punishment
          for the sin of idolatry (on the horizontal level attraction to the same sex reflects
          worship of another creature on the vertical level instead of worshipping the creator):
          <em>&ldquo;because they exchanged the truth about God for a lie and worshiped and
          served the creature rather than the Creator, who is blessed forever! Amen. For this
          reason God gave them up to dishonorable passions. For their women exchanged natural
          relations for those that are contrary to nature; and the men likewise gave up natural
          relations with women and were consumed with passion for one another, men committing
          shameless acts with men and receiving in themselves the due penalty for their
          error.&rdquo;</em> (Romans 1:25&ndash;27). Since we have all sinned (lied, harbored
          lustful thoughts, committed idolatry and stolen) so many times in our lives, we are all
          destined to end up in hell.
        </p>

        <p className="gospel-paragraph">
          God is holy and just. As a righteous Judge, He punishes sin. Any sin (such as lying
          or lustful thoughts) is a violation of His infinite holiness; it provokes His infinite
          wrath and is therefore punished with eternal death in hell, which is described as the
          lake of fire, a place where the fire is never quenched, the worm never dies, a place where
          there will be weeping and gnashing of teeth, outer darkness, and a place of eternal
          torment where there will be no rest for the worshippers of the beast.
        </p>

        <p className="gospel-paragraph gospel-question">Is there any hope?</p>

        <p className="gospel-paragraph gospel-answer">Yes, there is!</p>

        <p className="gospel-paragraph">
          God, in His mercy, sent His only Son, Jesus Christ, to rescue us by taking our
          punishment on the cross. Jesus Christ lived a life of perfect righteousness in our
          place, died on the cross to pay the penalty for our sin, and resurrected on the third
          day. <em>&ldquo;For our sake he made him to be sin who knew no sin, so that in him we
          might become the righteousness of God&rdquo;</em> (2 Corinthians 5:21). This Bible
          verse describes the great exchange: Jesus Christ took the sins of all believers upon
          Himself and accepted the punishment&mdash;the curse&mdash;that believers deserved for
          their sin; in exchange, God imputes, or credits, the righteousness of Jesus Christ to
          all believers so that they might possess the eternal life that Jesus Christ deserves.
        </p>

        <p className="gospel-paragraph">
          Repent of your sins and believe in Jesus Christ as LORD (God) and Savior, then you
          will be saved from hell and death and will receive the gift of eternal life. God is
          one, yet He exists in three distinct persons: the Father, the Son, and the Holy
          Spirit. The Son of God became man 2,000 years ago&mdash;taking on flesh to save
          us&mdash;by living a life of perfect righteousness on our behalf and dying on the
          cross. Only One who was truly God and truly man could pay the price for our sin. Only
          He could bear the eternal punishment we deserved. Only He could drink the infinite cup
          of God&rsquo;s wrath. Jesus Christ, as God-man, took upon Himself the infinite punishment
          that believers deserved in hell.
        </p>

        <p className="gospel-paragraph">
          <em>&ldquo;For by grace you have been saved through faith. And this is not your own
          doing; it is the gift of God, not a result of works, so that no one may
          boast&rdquo;</em> (Ephesians 2:8&ndash;9). This verse tells us that salvation is not
          earned by works but is a free gift. Good works of unbelievers are like filthy rags in
          God&rsquo;s eyes; they are sin because when they do their good works they do not do
          them out of perfect love toward the true triune God. As it is written:
          <em>&ldquo;None is righteous, no, not one; no one understands; no one seeks for God.
          All have turned aside; together they have become worthless; no one does good, not even
          one.&rdquo;</em> (Romans 3:10&ndash;12). But when you believe in Jesus Christ, His
          righteousness is credited to you. Faith is
          like a hand that receives Jesus Christ. Yet even faith itself comes from God.
          Therefore, salvation is God&rsquo;s work from beginning to end. However, Roman
          Catholic churches (which are false churches because they teach the false Gospel)
          teach that salvation is by faith and our own good works, which contradicts this
          verse. Therefore, trust only in Jesus Christ for salvation, not in your own good
          works.
        </p>

        <blockquote className="gospel-verse">
          &ldquo;For God so loved the world, that he gave his only Son, that whoever believes in
          him should not perish but have eternal life.&rdquo;
          <cite>John 3:16</cite>
        </blockquote>

        <h3 className="gospel-subtitle gospel-resources-title"></h3>

        <ul className="gospel-resources-list">
          <li>
            First of all, I recommend you read the word of the Lord Jesus Christ in the
            ESV translation:{' '}
            <a href="https://www.esv.org/" target="_blank" rel="noopener noreferrer">
              https://www.esv.org/
            </a>
          </li>
          <li>
            The Second London Baptist Confession of Faith:{' '}
            <a href="https://founders.org/library-book/1689-confession/" target="_blank" rel="noopener noreferrer">
              https://founders.org/library-book/1689-confession/
            </a>
          </li>
          <li>
            Sermons:{' '}
            <a href="https://www.youtube.com/@GraceChurchSunValley" target="_blank" rel="noopener noreferrer">
              https://www.youtube.com/@GraceChurchSunValley
            </a>
          </li>
          <li>
            Ministries:{' '}
            <a href="https://www.ligonier.org/" target="_blank" rel="noopener noreferrer">https://www.ligonier.org/</a>,{' '}
            <a href="https://www.desiringgod.org/" target="_blank" rel="noopener noreferrer">https://www.desiringgod.org/</a>,{' '}
            <a href="https://www.gotquestions.org/" target="_blank" rel="noopener noreferrer">https://www.gotquestions.org/</a>,{' '}
            <a href="https://www.gty.org/" target="_blank" rel="noopener noreferrer">https://www.gty.org/</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default GospelMessage;
